import { useEffect } from 'react'
import { useSearchParams } from 'react-router-dom'
import useFilterStore from '@/store/useFilterStore'

/**
 * URLパラメータからフィルターを自動設定するフック
 * YouTube投稿などからの流入時に使用
 * 
 * 使用例:
 * ?from=youtube&prefecture=40&team=123&startYear=2020&endYear=2024
 */
export const useURLParams = () => {
  const [searchParams] = useSearchParams()
  const {
    setSelectedPrefectures,
    setSelectedTeams,
    setStartYear,
    setEndYear,
    setSelectedCategory,
    setSelectedGeneration,
  } = useFilterStore()

  useEffect(() => {
    // URLパラメータから値を取得
    const prefectureParam = searchParams.get('prefecture')
    const prefecturesParam = searchParams.get('prefectures')
    const teamParam = searchParams.get('team')
    const teamsParam = searchParams.get('teams')
    const startYearParam = searchParams.get('startYear')
    const endYearParam = searchParams.get('endYear')
    const categoryParam = searchParams.get('category')
    const generationParam = searchParams.get('generation')

    // 都道府県の設定
    if (prefectureParam) {
      const prefectureId = parseInt(prefectureParam)
      if (!isNaN(prefectureId)) {
        setSelectedPrefectures([prefectureId])
      }
    } else if (prefecturesParam) {
      const prefectureIds = prefecturesParam
        .split(',')
        .map(id => parseInt(id))
        .filter(id => !isNaN(id))
      if (prefectureIds.length > 0) {
        setSelectedPrefectures(prefectureIds)
      }
    }

    // チームの設定
    if (teamParam) {
      const teamId = parseInt(teamParam)
      if (!isNaN(teamId)) {
        setSelectedTeams([teamId])
      }
    } else if (teamsParam) {
      const teamIds = teamsParam
        .split(',')
        .map(id => parseInt(id))
        .filter(id => !isNaN(id))
      if (teamIds.length > 0) {
        setSelectedTeams(teamIds)
      }
    }

    // 年度の設定
    if (startYearParam) {
      const year = parseInt(startYearParam)
      if (!isNaN(year)) {
        setStartYear(year)
      }
    }

    if (endYearParam) {
      const year = parseInt(endYearParam)
      if (!isNaN(year)) {
        setEndYear(year)
      }
    }

    // カテゴリの設定
    if (categoryParam) {
      setSelectedCategory(categoryParam)
    }

    // 世代の設定（setSelectedGenerationが存在する場合のみ）
    if (generationParam && setSelectedGeneration) {
      setSelectedGeneration(generationParam)
    }
  }, [
    searchParams,
    setSelectedPrefectures,
    setSelectedTeams,
    setStartYear,
    setEndYear,
    setSelectedCategory,
  ])
}

